import { useEffect, useState } from 'react';

/** Returns `value` after it has stopped changing for `delay` ms — for debounced live checks/searches. */
export function useDebounce<T>(value: T, delay = 500): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);
  return debounced;
}
